import zh_about from './about_zh.js';
import sustainability_zh from './sustainability_zh.js';
import server_zh from './server_zh.js';
import solution_zh from './solution_zh.js';
export default {
  nav: {
    home: '首页',
    solution: '方案与产品',
    store: '储能',
    datacenter: '数据中心',
    charging: '充电桩/充电设备',
    photovoltaic: '光伏',
    windpower: '风电',
    service: '服务支持',
    sustainability: '可持续发展',
    about: '关于我们',
  },
  homepage: {
    text0: '数字能源，储之有道',
    text1:
      '聚焦能源领域“发、输、配、用”全场景，提供储能管理系统、储能变流器、储能一体柜、工业电源产品。为生态伙伴提供“电能转换、电能治理、电能管理、电源控制”产品与解决方案',
    entype: {
      n0: '光 Solar',
      n1: '风 Wind',
      n2: '储能 Energy Storage',
      n3: '电 Power',
      n4: '数据中心 Data Center',
    },
    enimg: require('@/assets/images/icon0.gif'),
    sztext: require('@/assets/images/icon2.gif'),
    brand: require('@/assets/images/carousel1.gif'),
    advantages: {
      Icon0: {
        title: '行业领先老字号',
        concent: '拥有专业、先进的生产设备，品控精良、人员专业。',
      },
      Icon1: {
        title: '行业领先老字号',
        concent: '拥有专业、先进的生产设备，品控精良、人员专业。',
      },
      Icon2: {
        title: '技术先进',
        concent: '创新型科技企业，拥有专业化的开发团队和丰富的行业经验',
      },
      Icon3: {
        title: '售后服务优势',
        concent: '提供优质产品和满意服务，遵循现代化质量管理体系',
      },
    },
  },
  footer: {
    name: '深圳市寰能数航有限公司',
    email: '邮箱: hailong@gedntech.com',
    hotline: '热线：400 - 852 - 976',
    landline: '座机：0755 - 82367936',
    reserved: '© 2026 深圳市环能数航有限公司 版权所有',

    about: '关于我们',
    aboutus: '公司简介',
    honors: '荣誉资质',

    datacenter: '数据中心',
    project: '项目概览',
    planning: '规划布局',
    visit: '机房参观',

    contact: '联系我们',
    contactus: '联系方式',
  },
  logo: require('@/assets/images/logo1.jpg'),
  language: '中文',
  title: '欢迎来到我们企业官网',
  button: {
    submit: '提交',
  },
  ...zh_about,
  ...sustainability_zh,
  ...server_zh,
  ...solution_zh,
};
